import { render, staticRenderFns } from "./personnelManagement.vue?vue&type=template&id=4a01c2de&scoped=true&"
import script from "./personnelManagement.vue?vue&type=script&lang=js&"
export * from "./personnelManagement.vue?vue&type=script&lang=js&"
import style0 from "./personnelManagement.vue?vue&type=style&index=0&id=4a01c2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a01c2de",
  null
  
)

export default component.exports